import React, { useEffect, useState } from 'react';
import '../App.css';
import { isEmpty } from 'lodash';
import { logout, setUserId } from '../features/auth/authSlice'
import { userLogout } from '../features/auth/authActions'
import { fetchUser } from '../features/user/userSlice'
import { useNavigate } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from '../app/hooks'
import { IInject, IScenario } from '../interfaces';
import type { RootState } from '../store'
import Modal from 'react-modal';
import {parseJwt} from "../helpers/helperFunctions";

interface HeaderProps {
    selectedScenario: IScenario;
    injectItem: IInject;
    intervalHandler: (command: string, gameId: string, inGame: boolean) => void;
    onExit?: () => Promise<void>;
    onNavTimeline?: () => Promise<void>;
    onNavSettings?: () => Promise<void>;
  }

  const customSmallStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '480px',
      transform: 'translate(-50%, -50%)',
    }
};

Modal.setAppElement('#root');

const Header: React.FC<HeaderProps> = ({
    selectedScenario, injectItem, intervalHandler, onExit, onNavTimeline, onNavSettings }) => {
    
    const { accessToken } = useAppSelector((state: RootState) => state.auth)
    
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    let [loggedIn, setLoggedIn] = useState<boolean>(false);
    let [userInfo, setUserInfo] = useState<any>({});
    const [checkSaveModalIsOpen, setCheckSaveModalIsOpen] = useState<boolean>(false);

    useEffect(() => {
        const getUserInfo = async (id: string) => {
            let user: any = await dispatch(fetchUser(id))
            if (user.payload === undefined || user.error !== undefined) {
                dispatch(logout())
                setLoggedIn(false)
            } else {
                setUserInfo(user.payload)
                dispatch(setUserId());
                setLoggedIn(true)
            }
        }

        intervalHandler("stop", "", false)

        if (accessToken) {
            let parsedJWT = parseJwt(accessToken)
            getUserInfo(parsedJWT.id)
            dispatch(setUserId());
        } else {
          setLoggedIn(false)
          navigate('/login')
        }
      }, [navigate, accessToken, dispatch, setLoggedIn]) // eslint-disable-line react-hooks/exhaustive-deps

    const clickLogout = async (ev: React.MouseEvent) => {
        await dispatch(userLogout())
        dispatch(logout())
        intervalHandler("stop", "", false)
        setLoggedIn(false)
    }

    const closeCheckSaveModal = () => {
        setCheckSaveModalIsOpen(false);
    }

    const checkForUnsaved = () => {
        if (onExit) {
            onExit().then(() => {
                navigate('/player')
            }).catch((e) => {
                console.log('Exit Cancelled');
            })
            return;
        }
        navigate('/player')
    }

    const locationString = document.location.toString();
    const { searchParams } = new URL(locationString);
    const panel = searchParams.get('showpanel');
    const isTimeline = panel === 'timeline';
    const showInjectCrumb = (isTimeline || !isEmpty(injectItem.id));

    return (
        <header className="txp-sc-header">
            <div onClick={checkForUnsaved} className="header-logo-link">
                <img className="txp-sc-logo-icon" src="img/txp-build-logo.svg" alt="logo" />
                <div className="txp-sc-title">TXP CREATOR</div>
            </div>
            
            {!isEmpty(selectedScenario.name) &&
            <><div className={`scenario-leader${showInjectCrumb ? ' clickable col-3' : ''}`} onClick={onNavSettings}>
                <div className="scenario-leader-label">
                Scenario
                </div>
                <div className="scenario-leader-title">
                {selectedScenario.name}
                </div>
            </div>
            {showInjectCrumb &&
            <div className={`scenario-leader col-3`}>
                <img src="img/chevron-right-blue.svg" alt="Separator Icon" className="chevron-right-blue"/>
                <div className={`scenario-leader-content ${!isEmpty(injectItem.id) ? 'clickable' : ''}`}
                    onClick={onNavTimeline} >
                    <div className="scenario-leader-label">
                        Injects
                    </div>
                    <div className="scenario-leader-title">
                        Timeline
                    </div>
                </div>
            </div>
            }
            {!isEmpty(injectItem.id) &&
            <div className={`scenario-leader col-3`}>
                <img src="img/chevron-right-blue.svg" className="chevron-right-blue" alt="icon" />
                <div className="scenario-leader-content">
                    <div className="scenario-leader-label">
                    Inject
                    </div>
                    <div className="scenario-leader-title">
                    {injectItem.name}
                    </div>
                </div>
            </div>
            }
            </>
            }

            <button className="txp-sc-exit" onClick={checkForUnsaved}>
                <div className="exit-main">
                    <span>Exit</span>
                </div>
            </button>

            <div className='header-status'>
                <div className="header-info">
                    <div className="header-icon">
                        <img src="img/person.svg" alt="person" className="header-info-person" />
                    </div>
                    <div className="header-info-list">
                        {loggedIn ?
                            <div className="header-info-item header-username">
                                <img src="img/person.svg" className="header-info-icon" alt="user" />
                                <div className="header-info-id">{userInfo.email}</div>
                            </div>
                        : ''}
                        <div className="header-info-item" onClick={clickLogout}>
                            <img src="img/logout.svg" className="header-info-icon" alt="logout" />
                            <button className='logout-link'>
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                isOpen={checkSaveModalIsOpen}
                onRequestClose={closeCheckSaveModal}
                style={customSmallStyles}
                contentLabel="Failed Host Modal"
            >
                <div className="new-modal-header">Confirm Exit</div>

                <div className="new-modal-text"><span className="modal-scenario-name">{
                    isEmpty(selectedScenario.name) ? 'Unnamed Scenario' : selectedScenario.name
                }</span> has unsaved changes that will be lost if you exit now. Do you want to exit anyway?</div>

                <button onClick={closeCheckSaveModal} className="new-cancel-btn"><span>No</span></button>
                <button onClick={() => navigate('/player')} className="new-confirm-btn"><span>Yes</span></button>
            </Modal>
        </header>
    );
}

export default Header